<div (window:resize)="onResize($event)" (mouseenter)="mouseEnter()">
    <div class="container-fluid">

        <div class="btns-container" style="position:absolute;top:7px;right:1px;">

            <a id="restoreAssessments" (click)="openRestoreAssessmentsConfirmationModal()" [ngClass]="{'btn-primary': _Globals.canRestoreAssessments, 'btn-gray': !_Globals.canRestoreAssessments}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                <i class="fas fa-archive text-white-50"> <span class="button-text"> Restore </span></i>
            </a>
        </div>

        <ng-container *ngIf="loading">
            <div class="loading text-center">
                <br />
                <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                <br />
                <p>Loading, please wait...</p>
            </div>
        </ng-container>

        <div class="row">

            <div>
                <ul class="nav nav-tabs archivedTabs">
                    <li (click)="tabSelected(4.1)" class="active"><a data-toggle="tab" href="#archivedTab1">ELI - Self Assessment</a></li>
                    <li (click)="tabSelected(4.2)"><a data-toggle="tab" href="#archivedTab2">ELI 360</a></li>
                </ul>
            </div>

            <div class="tab-content archivedTabs">
                <div id="archivedTab1" class="tab-pane fade in active">
                    <div class="row container-fluid">
                        <div class="col-xs-9 col-sm-5">
                            <tag-input [(ngModel)]='tags'
                                       [addOnBlur]="true"
                                       (onRemove)="onItemRemoved(1, $event)"
                                       (onAdd)="onItemAdded(1, $event)"
                                       [secondaryPlaceholder]="placeholder"
                                       [placeholder]="placeholder"
                                       [inputId]="'archivedTagsInput'"
                                       (onFocus)="onFocusInput()"
                                       [theme]="'foundation-theme'"></tag-input>
                            <i class="fas fa-search searchIcon" (click)="focusTagsInput('archivedTagsInput')"></i>
                            <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(1)">My tags</a>
                        </div>
                        <i style="margin-left: 15px;position: relative;top: 20px;" [popover]="help" class="fas fa-question-circle pointer"></i>
                        <popover-content #help
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>

                    <br />

                    <div id="restoredAssessments" style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="this._Globals.archivedRegularData"
                                         [columnDefs]="dataHeaders"
                                         [enableSorting]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onRowClicked($event)"
                                         (gridReady)="onGridReady(1, $event)"
                                         [rowSelection]="rowSelection"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         [floatingFilter]="true"
                                         (selectionChanged)="onSelectionChanged($event)">
                        </ag-grid-angular>
                    </div>
                </div>

                <div id="archivedTab2" class="tab-pane fade">
                    <div class="row container-fluid">
                        <!--<div class="col-xs-4 col-sm-offset-5 col-sm-2" >
                            <h5>Search by tag:</h5>
                        </div>-->
                        <div class="col-xs-9 col-sm-5">
                            <tag-input [(ngModel)]='tags360'
                                       [addOnBlur]="true"
                                       (onRemove)="onItemRemoved(2, $event)"
                                       (onAdd)="onItemAdded(2, $event)"
                                       [secondaryPlaceholder]="placeholder"
                                       [placeholder]="placeholder"
                                       [inputId]="'archivedTagsInput360'"
                                       (onFocus)="onFocusInput()"
                                       [theme]="'foundation-theme'"></tag-input>
                            <i class="fas fa-search searchIcon" (click)="focusTagsInput('archivedTagsInput360')"></i>
                            <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(2)">My tags</a>
                        </div>
                        <i style="margin-left: 15px;position: relative;top: 20px;" [popover]="help360" class="fas fa-question-circle pointer"></i>
                        <popover-content #help360
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>

                    <br />

                    <div id="archivedAssessments" style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="this._Globals.archived360Data"
                                         [columnDefs]="dataHeaders"
                                         [enableSorting]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onRowClicked($event)"
                                         (gridReady)="onGridReady(2, $event)"
                                         [rowSelection]="rowSelection"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         [floatingFilter]="true"
                                         (selectionChanged)="onSelectionChanged($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="archivedTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">My tags</h2>
                <button (click)="closeTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div *ngIf="selectedCoachTags.length > 0" class="tags-wrap">
                    <div *ngFor="let tag of selectedCoachTags; let i = index;" class="tag">
                        {{tag.Text}}
                        <span title="Delete" class="animate fadeInRight" (click)="removeTag(i, tag.Text)">&times;</span>
                    </div>
                </div>

                <div *ngIf="selectedCoachTags.length === 0">
                    <input type="text" placeholder="Select tags from the table" id="placeholderInput" readonly />
                </div>

                <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #coachTagsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="gridOptions"
                                     [rowData]="coachTags"
                                     [columnDefs]="coachTagsHeaders"
                                     (gridReady)="onCoachTagsGridReady($event)"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     [pagination]="true"
                                     [paginationPageSize]="15"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     (rowClicked)="onCoachTagsRowClicked($event)"
                                     (selectionChanged)="onCoachTagsSelectionChanged($event)">
                    </ag-grid-angular>
                </div>

            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addNewCoachTags()" [disabled]="selectedCoachTags.length === 0" type="button" class="btn btn-primary">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Restore Assessments confirmation modal -->
<div id="restoreConfirmationModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Restore Assessements</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to restore the selected assessments?</p>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button *ngIf="!restoring;" type="button" data-dismiss="modal" class="btn btn-secondary">No</button>
                        <button *ngIf="!restoring; else restoringElse;" (click)="restoreAssessments()" type="button" class="btn btn-primary">Yes</button>
                        <ng-template #restoringElse>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Restoring
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>